function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], function ($) {
      return factory($, window, document);
    });
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    // CommonJS
    module.exports = function (root, $) {
      if (!root) {
        // CommonJS environments without a window global must pass a
        // root. This will give an error otherwise
        root = window;
      }
      if (!$) {
        $ = typeof window !== 'undefined' ?
        // jQuery's factory checks for a global window
        require('jquery') : require('jquery')(root);
      }
      return factory($, root, root.document);
    };
  } else {
    // Browser
    factory(jQuery, window, document);
  }
})(function ($, window, document, undefined) {
  // eslint-disable-line
  "use strict";

  var addDateRangePicker = require('./addDateRangePicker');
  require('tristate/jquery.tristate.js');
  require('multiple-select');
  require('multiple-select/src/multiple-select.scss');
  var addColumnSearchInputs = function addColumnSearchInputs($table, passedOptions) {
    $('thead th[data-searchable!="false"]', $table).each(function () {
      var $th = $(this);
      if ($th.data('datatableMultiselect')) {
        addMultiselect($th);
      } else if ($th.data('datatableCheckbox')) {
        addCheckbox($th);
      } else {
        addInputBasedOnText($th);
        if ($th.data('datatableRange')) {
          addDateRange($th, passedOptions);
        }
      }
    });
  };
  function addMultiselect($th) {
    var text = $th.text();
    if (text.length > 0) {
      $th.data("original-text", text);
    }
    var $select = $('<select>').attr('multiple', 'multiple').attr('trk-datatables-select', true);
    var _iterator = _createForOfIteratorHelper($th.data().datatableMultiselect),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref = _step.value;
        var key = _ref.key;
        var value = _ref.value;
        var selected = _ref.selected;
        var $option = $('<option/>').attr('value', value).text(key);
        if (selected) {
          $option.attr('selected', 'selected');
        }
        $select.append($option);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    $th.html($select);
    // http://multiple-select.wenzhixin.net.cn/examples#basic.html
    $('select', $th).multipleSelect({
      container: 'body',
      width: '110px',
      dropWidth: '150px',
      placeholder: text
    });
    $('button', $th).on('click', function (e) {
      e.stopPropagation(); // prevent reordering since it is on thead
    });
  }

  function _titleize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  function _outputFunc(id) {
    return function (state, value) {
      return $("#" + id).text(_titleize(value));
    };
  }
  function addCheckbox($th) {
    var text = $th.text();
    if (text.length > 0) {
      $th.data("original-text", text);
    }
    var initialValue;
    if (typeof $th.data().datatableSearchValue !== 'undefined') {
      if ($th.data().datatableSearchValue === true) {
        initialValue = 'checked="checked"';
      } else if ($th.data().datatableSearchValue === false) {
        initialValue = '';
      }
    } else {
      initialValue = "indeterminate='1'";
    }
    var id = Math.random().toString(36).substr(2, 9);
    $th.html("\n      <label for='".concat(id, "' class='trk-column-checkbox'>\n        ").concat(text, "\n        <input id='").concat(id, "' type='checkbox' ").concat(initialValue, " trk-datatables-checkbox />\n        <span id='").concat(id, "-output'></span>\n      </label>\n    "));
    $("#".concat(id)).tristate({
      checked: 'true',
      unchecked: 'false',
      indeterminate: 'any',
      init: _outputFunc("".concat(id, "-output")),
      change: _outputFunc("".concat(id, "-output"))
    });
    return $('label', $th).on('click', function (e) {
      return e.stopPropagation();
    });
  }
  function addInputBasedOnText($th) {
    var text = $th.text();
    if (text.length == 0) return;
    var klass = '';
    if (text.toUpperCase() == 'ID') {
      klass = 'trk-column-input__small';
    }
    $th.html("<input class='trk-column-input ".concat(klass, "' type='text' placeholder='").concat(text, "' trk-datatables-input />"));
    $th.data("original-text", text);
    $('input', $th).on('click', function (e) {
      e.stopPropagation(); // prevent reordering since it is on thead
    });

    if ($th.data('datatableSearchValue')) {
      $('input', $th).val($th.data('datatableSearchValue'));
    }
  }
  function addDateRange($th, passedOptions) {
    var $input = $('input', $th);
    $input.data('dateRange', $(this).data('datatableRange'));
    $input.data('predefinedRanges', $(this).data('datatablePredefinedRanges'));
    addDateRangePicker($input, passedOptions);
  }
  return addColumnSearchInputs;
});